<h4 mat-dialog-title>{{'pages.leavePageDialog.header' | translate}}</h4>
<mat-dialog-content>{{'pages.leavePageDialog.content' | translate}}</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close class="fill-button" (click)="closeDialog(false)">{{'pages.leavePageDialog.stay' | translate}}</button> 
  <!-- The mat-dialog-close directive optionally accepts a value as a result for the dialog. -->
  <button mat-stroked-button  (click)="closeDialog(true)">{{'pages.leavePageDialog.clear' | translate}}</button>
</mat-dialog-actions>

<!-- [mat-dialog-close]="true" -->